import PageHeader from "@/components/PageHeader";
import { CURRENT_USER, MOCK_TOKEN_TX, formatTimeFromNow } from "@/lib/mockData";
import { Coins } from "lucide-react";

const Tokens = () => {
  return (
    <div data-testid="tokens-page">
      <PageHeader title="Tokens" subtitle="Earn by showing up. Spend on visibility." />

      <div className="brutal-card p-6 bg-[#FFFBEB]">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 brutal-border bg-white rounded-lg flex items-center justify-center">
            <Coins className="w-5 h-5" />
          </div>
          <span className="label-mono">Balance</span>
        </div>
        <div className="font-heading font-black text-6xl leading-none">{CURRENT_USER.tokens}</div>
        <div className="text-sm text-[#555555] mt-2">Earned + spent across activities, referrals and check-ins.</div>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-4">
        <Earn n={5} label="Per join" />
        <Earn n={10} label="Check-in" />
        <Earn n={25} label="Referral" />
      </div>

      <h3 className="font-heading font-bold text-xl mt-6 mb-3">Transactions</h3>
      <div className="brutal-card divide-y-2 divide-[#0A0A0A]">
        {MOCK_TOKEN_TX.map((t) => (
          <div key={t.id} className="p-4 flex items-center justify-between" data-testid={`token-tx-${t.id}`}>
            <div className="min-w-0">
              <div className="font-bold text-sm truncate">{t.reason}</div>
              <div className="text-[10px] text-[#555555] font-mono">{formatTimeFromNow(t.iso)}</div>
            </div>
            <div className={`font-mono font-bold text-base ${t.amount > 0 ? "text-[#34C759]" : "text-[#FF6A2C]"}`}>
              {t.amount > 0 ? "+" : ""}{t.amount}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Earn = ({ n, label }) => (
  <div className="brutal-card p-3 text-center">
    <div className="font-heading font-black text-2xl text-[#34C759]">+{n}</div>
    <div className="label-mono text-[#555555] mt-1">{label}</div>
  </div>
);

export default Tokens;
